import { jsx as _jsx } from "react/jsx-runtime";
import * as Common from '_common';
import { PageLayoutController } from './PageLayoutController';
import { ErrorOverlay } from './Overlay';
export function LoadingPage(props) {
    let lines = [];
    if (typeof props.loadingState == 'string') {
        lines = [props.loadingState];
    }
    else {
        lines = props.loadingState;
    }
    return (_jsx(PageLayoutController, { preferMinimal: true, title: { cs: 'Michalf.cz', en: 'Michalf.cz' }, children: _jsx("ul", { children: lines.map((title, i) => (_jsx("li", { children: title }, i))) }) }));
}
export function ErrorScreen(props) {
    return (_jsx(PageLayoutController, { preferMinimal: true, title: { cs: 'Michalf.cz', en: 'Michalf.cz' }, children: _jsx(ErrorOverlay, { type: Common.OverlayType.Error }) }));
}
